export default __webpack_public_path__ + "static/media/cancer.e090126c.svg";